var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('skeleton-loader',{attrs:{"type":"square","width":_vm.width,"height":_vm.height,"rounded":true,"animation":"fade"}})}
var staticRenderFns = []

export { render, staticRenderFns }